function htmlMarkup(html) {
  return { __html: html || '' }
}

function ProductBadge({ product, labels }) {
  if (!product.isInStock) {
    return <span className="nova-new-product-widget__badge">{labels.outOfStock || 'Rupture'}</span>
  }

  if (product.isOnSale) {
    return <span className="nova-new-product-widget__badge">{labels.onSale || 'Promo'}</span>
  }

  return <span className="nova-new-product-widget__badge">{labels.newProduct || 'Nouveau'}</span>
}

function ProductCard({ product, labels }) {
  const categories = Array.isArray(product.categories) ? product.categories : []

  return (
    <article className="nova-new-product-widget__card">
      <a className="nova-new-product-widget__media" href={product.url} aria-label={`${labels.viewProduct || 'Voir le produit'}: ${product.name}`}>
        {product.image?.src ? (
          <img className="nova-new-product-widget__image" src={product.image.src} alt={product.image.alt || ''} loading="lazy" />
        ) : (
          <span className="nova-new-product-widget__placeholder" aria-hidden="true">
            {product.name?.slice(0, 1) || ''}
          </span>
        )}
        <ProductBadge product={product} labels={labels} />
      </a>

      <div className="nova-new-product-widget__card-body">
        {categories.length ? <div className="nova-new-product-widget__meta">{categories.join(' / ')}</div> : null}

        <h3 className="nova-new-product-widget__product-title">
          <a href={product.url}>{product.name}</a>
        </h3>

        {product.priceHtml ? <div className="nova-new-product-widget__price" dangerouslySetInnerHTML={htmlMarkup(product.priceHtml)} /> : null}
      </div>
    </article>
  )
}

export function NewProductWidget({ payload }) {
  const labels = payload.labels || {}
  const products = Array.isArray(payload.products) ? payload.products : []

  if (!products.length) {
    if (!payload.showEmptyNotice) return null

    return <p className="nova-new-product-widget__notice">{labels.empty || 'Aucun produit publie pour le moment.'}</p>
  }

  return (
    <section className="nova-new-product-widget" style={payload.style || {}}>
      <header className="nova-new-product-widget__header">
        <div className="nova-new-product-widget__heading">
          {payload.title ? <h2 className="nova-new-product-widget__title">{payload.title}</h2> : null}
          {payload.description ? <p className="nova-new-product-widget__description">{payload.description}</p> : null}
        </div>

        {payload.buttonLabel && payload.buttonUrl ? (
          <a className="nova-new-product-widget__button" href={payload.buttonUrl}>
            {payload.buttonLabel}
          </a>
        ) : null}
      </header>

      <div className="nova-new-product-widget__grid">
        {products.map((product) => (
          <ProductCard key={product.id} product={product} labels={labels} />
        ))}
      </div>
    </section>
  )
}
